export default {
    version: null
};
